import React, { FC, useEffect, useState } from 'react';
import { useStoreon } from 'storeon/react';
import cnBind from 'classnames/bind';
import { GxRadio, GxTabPanel } from '@garpix/garpix-web-components-react';
import dayjs from 'dayjs';
import { toast } from 'react-toastify';
import { IUser, IUserDepositList, TUserDeposit } from '@/types';
import { Events, State } from '@/interfaces';
import { api } from '@/api';
import classNames from 'classnames';
import { DEPOSIT_PAYMENT_TITLE } from '@/apps/Applications/consts';
import { DEPOSIT_TYPE } from './types';
import ModalExtendDeposit from '../../../ModalExtendDeposit';
import {
  ARR_TYPE,
  MODAL_USER_PANELS,
  TITLE_DEPOSIT_NUll,
  TYPE_USER,
  TYPES_DEPOSITS,
} from '../../../../../../const';
import styles from './styles/index.module.scss';
import Button from '../../../../../../components/Button';
import useModalFlag from '../../../../../../hooks/useModalFlag';
import ReturnDeposit from '../../../ReturnDeposits';
import ReturnMoneyDeposit from '../../../ReturnMoneyDeposit';
import { IDepositInfo } from '../../types';
import { defaultValue } from './const';

interface IDepositsPanel {
  userData: IUser | null;
}

const DepositsPanel: FC<IDepositsPanel> = ({ userData }) => {
  const { dispatch, depositListUser, currentUser, selectedUser } = useStoreon<State, Events>(
    'depositListUser',
    'currentUser',
    'selectedUser'
  );
  const [activeItem, setActiveItem] = useState<TYPES_DEPOSITS>(TYPES_DEPOSITS.PIPE);
  const { flag: modalReturn, setModalFlag: toggleModalReturn } = useModalFlag();
  const { flag: modalExtend, setModalFlag: toggleModalExtend } = useModalFlag();

  const list = depositListUser[ARR_TYPE[activeItem] as keyof IUserDepositList];

  const isNotMoneyDeposit = typeof list !== 'number'

  const filteredList = isNotMoneyDeposit ? list.filter((deposit) =>
      deposit.minutes !== 0 || deposit.sets !== 0 || deposit.rent_pay_count !== 0
  ) : [];
  const cn = cnBind.bind(styles);
  const [depositInfo, setDepositInfo] = useState<IDepositInfo>(
    defaultValue
  );

  useEffect(() => {
    return () => {
      dispatch('depositListUser/save', {
        deposit_money: 0,
        minute_deposits: [],
        set_deposits: [],
      });
    };
  }, []);

  const handleClickReturn = () => {
    toggleModalReturn();
  };

  const isDisableReturnBtn = () => {
    return Object.is(depositInfo, defaultValue) && Math.trunc(depositListUser[ 'deposit_money' ]) === 0;
  };

  const isDisabledExtendBtn = () => {
    const isRent = !depositInfo.data.rent_pay_count
    return !(depositInfo.type !== DEPOSIT_TYPE.MONEY && depositInfo.data.expiry_at && isRent);
  };

  const handleClickExtend = () => {
    toggleModalExtend();
  };
  
  const extendDepositData = ()=>{
    if (selectedUser === null) return
    api.tariff.extendDeposit(depositInfo.data.id).then(()=>{
      dispatch('depositListUser/get', { user_id: selectedUser.id, is_has_resource: true });
      toast.success(`Продление депозита "${depositInfo.data.title}" прошло успешно`)
      toggleModalExtend();
    }).catch(() => toast.error('При продлении депозита произошла ошибка '))
  }

  const resourceType = (item: TUserDeposit) => {
    const value = activeItem === TYPES_DEPOSITS.WAVE
      ? item.rent_pay_count || item.sets
      : item.minutes

    const label = activeItem === TYPES_DEPOSITS.PIPE
      ? 'мин.'
      : item.rent_pay_count ? 'ap.' : 'сет'

    return `${value} ${label}`
  }
  
  const updateDepositData = (deposit_id: number) => {
    api.user
      .getDepositListUser({ user_id: userData?.id, deposit_id })
      .then((res: any) => {
        setDepositInfo({ data: res, type: activeItem });
      });
  };

  return (
    <GxTabPanel name={MODAL_USER_PANELS.deposits}>
      <>
        <div className={styles['block']}>
          <h2 className={styles['title']}>Депозиты</h2>
          {currentUser.user_status !== TYPE_USER.VIEWER  && (
            <>
              <Button
                className={classNames(styles['extend-btn'], styles.btn)}
                theme='btn--outline_blue'
                onClick={handleClickExtend}
                disable={isDisabledExtendBtn()}
              >
                Продлить
              </Button>
              <Button
                className={styles.btn}
                theme='btn--outline_blue'
                onClick={handleClickReturn}
                disable={isDisableReturnBtn()}
              >
                Возврат
              </Button>
            </>
          )}
          <Button
            className={styles['onloading--btn']}
            onClick={() => {
              if (userData)
                dispatch('depositListUser/get', { user_id: userData.id, is_has_resource: true })
            }}
          >
            Обновить
          </Button>
        </div>
        <div className={styles['table']}>
          {userData && (
            <table>
              <thead>
                <tr>
                  <th>Название</th>
                  <th>Сумма</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    {currentUser.user_status !== TYPE_USER.VIEWER ? (
                      <GxRadio
                        name='deposit'
                        checked={depositInfo?.data.id === TYPES_DEPOSITS.MONEY}
                        onClick={() => setDepositInfo(defaultValue)}
                      >
                        {DEPOSIT_PAYMENT_TITLE.MONEY}
                      </GxRadio>
                    ) : 
                    <>
                      {DEPOSIT_PAYMENT_TITLE.MONEY}
                    </>
                    }
                  </td>
                  <td>{Math.trunc(depositListUser['deposit_money'])} ₽</td>
                </tr>
              </tbody>
            </table>
          )}
        </div>
        <div className={styles['second-table']}>
          <div className={styles['sort-menu']}>
            <Button
              className={cn({
                'sort-menu--btn': true,
                'sort-menu--btn_active': activeItem === TYPES_DEPOSITS.PIPE
              })}
              theme='btn--transparent_link'
              onClick={() => {
                setActiveItem(TYPES_DEPOSITS.PIPE)
                setDepositInfo(defaultValue)
              }}
            >
              Труба
            </Button>
            <Button
              className={cn({
                'sort-menu--btn': true,
                'sort-menu--btn_active': activeItem === TYPES_DEPOSITS.WAVE
              })}
              theme='btn--transparent_link'
              onClick={() => {
                setActiveItem(TYPES_DEPOSITS.WAVE)
                setDepositInfo(defaultValue)
              }}
            >
              Волна
            </Button>
          </div>
          <div className={styles['table']}>
            {isNotMoneyDeposit && list.length === 0 ? (
              <div className={styles['info']}>
                {TITLE_DEPOSIT_NUll[activeItem]} депозиты отсутствуют...
              </div>
            ) : (
              <table>
                <thead>
                  <tr>
                    <th>Название</th>
                    <th>Действителен до</th>
                    <th>Ресурс</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredList.map((item) => (
                      <tr key={item.id}>
                        <td>
                          {currentUser.user_status !== TYPE_USER.VIEWER ? (
                            <GxRadio
                              name='deposit'
                              checked={depositInfo?.data?.id === item.id}
                              onClick={() => {
                                setDepositInfo({
                                  data: item,
                                  type: activeItem
                                })
                              }}
                            >
                              {item.title}
                            </GxRadio>
                          ) : (
                            `${item.title}`
                          )}
                        </td>
                        <td>{item.expiry_at ? dayjs(item.expiry_at).format('YYYY.MM.DD') : '-'}</td>
                        <td>{resourceType(item)}</td>
                      </tr>
                    ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
      </>
      {depositInfo && depositInfo.type !== DEPOSIT_TYPE.MONEY && (
        <ReturnDeposit
          userInfo={userData}
          flag={modalReturn}
          onRequestClose={toggleModalReturn}
          data={depositInfo}
          updateDepositData={updateDepositData}
        />
      )}
      {depositInfo && depositInfo.type === DEPOSIT_TYPE.MONEY && (
        <ReturnMoneyDeposit
          userInfo={userData}
          flag={modalReturn}
          onRequestClose={toggleModalReturn}
          depositMoney={Math.trunc(depositListUser['deposit_money'])}
        />
      )}
      <ModalExtendDeposit
       flag={modalExtend}
       onRequestClose={toggleModalExtend}
       onSave={extendDepositData}
       depositName={depositInfo.data.title}/>
    </GxTabPanel>
  )
};

export default DepositsPanel;
